/**
 * Shared numeric constants — identical on server and client.
 * DO NOT EDIT in server/src/shared/common/ or phaser/src/shared/common/
 * Edit the canonical copy in shared/ and run: node scripts/sync-shared.js
 */

// Combat constants
export const BASE_ACCURACY = 0.75;
export const MAX_EVASION = 0.5;
export const DEFENSE_PLATFORM_DAMAGE_REDUCTION = 0.3;

// Resource constants
export const STARTING_CREDITS = 500;
export const BASE_PLANET_PRODUCTION = 3;
export const POWER_PLANT_BONUS = 3;

// Mining facility costs
export const MINING_FACILITY_COSTS = {
  level1: 75,
  level2: 100,
  level3: 150,
};
